import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";

import { Link } from "react-router-dom";
import RegionCreatePage from "./RegionCreatePage";

const AdminRegionsPage = () => {
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRegions = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/admin/regions/");
      setRegions(res.data || []);
    } catch (err) {
      console.error("❌ Fetch regions failed:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRegions();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("⚠️ Confirm delete?")) return;
    try {
      await axiosInstance.delete(`/admin/regions/${id}/`);
      setRegions((prev) => prev.filter((r) => r.id !== id));
    } catch (err) {
      console.error("❌ Delete region failed:", err);
    }
  };

  return (
    <div className="min-h-screen text-gray-900 dark:bg-dark-gradient">
      <main className="mx-auto px-4 py-6">
        <div className="grid grid-cols-1 md:grid-cols-10 gap-6">
          {/* LEFT: LIST 40% */}
          <section className="order-2 md:order-1 md:col-span-4">
            <div className="flex items-center justify-between">
              {/* <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-green-400 drop-shadow-md">
                🌍 Regions
              </h2> */}
            </div>

            <div className="overflow-x-auto rounded-2xl bg-white shadow-md ring-1 ring-black/5 dark:bg-black/30 dark:backdrop-blur-lg dark:shadow-2xl dark:border dark:border-gray-700 dark:ring-0">
              <table className="min-w-full text-sm">
                <thead className="text-gray-600 uppercase text-xs tracking-wider bg-gray-50 dark:bg-gray-900/60 dark:text-gray-300 dark:backdrop-blur">
                  <tr>
                    <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">Code</th>
                    <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">Name</th>
                    <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">ID</th>
                    <th className="px-4 md:px-6 py-3 md:py-4 text-left font-semibold">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-800 text-gray-200">
                  {loading ? (
                    <tr>
                      <td colSpan={4} className="text-center py-10 text-gray-500 font-medium">
                        ⏳ Loading regions...
                      </td>
                    </tr>
                  ) : regions.length === 0 ? (
                    <tr>
                      <td colSpan={4} className="text-center py-10 text-gray-500 font-medium">
                        🚫 No regions found.
                      </td>
                    </tr>
                  ) : (
                    regions.map((r) => (
                      <tr key={r.id} className="hover:bg-gray-900/30 transition">
                        <td className="px-4 md:px-6 py-3 md:py-4">{r.code}</td>
                        <td className="px-4 md:px-6 py-3 md:py-4">{r.name}</td>
                        <td className="px-4 md:px-6 py-3 md:py-4 text-xs">{r.id}</td>
                        <td className="px-4 md:px-6 py-3 md:py-4 space-x-3">
                          <Link
                            to={`/admin/regions/edit/${r.id}`}
                            className="px-3 py-1 rounded bg-yellow-500 hover:bg-yellow-600 text-black font-medium"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() => handleDelete(r.id)}
                            className="px-3 py-1 rounded bg-red-600 hover:bg-red-700 text-white font-medium"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </section>

          {/* RIGHT: CREATE 60% */}
          <aside className="order-1 md:order-2 md:col-span-6">
            <div className="rounded-2xl p-4 md:p-6 bg-white shadow-md ring-1 ring-black/5 dark:bg-black/30 dark:backdrop-blur-lg dark:shadow-2xl dark:border dark:border-gray-700 dark:ring-0 sticky md:top-6">
              <h3 className="text-lg font-semibold mb-4">Create Region</h3>
              <RegionCreatePage /* onSuccess={fetchRegions} */ />
            </div>
          </aside>
        </div>
      </main>
    </div>
  );
};

export default AdminRegionsPage;
